import React from "react";

import ButtonWithPopover from "../ButtonWithPopover";

import Button from "react-bootstrap/Button";

import "../PawStatus/PawStatus.css";

const DiscardFax = ({ discardFax, faxId, disallowEditing }) => {
  const handleDiscard = () => {
    discardFax(faxId);
  };

  const reference = "discardFax";

  return (
    <ButtonWithPopover
      placement="top"
      customRef={reference + "bwp"}
      buttonVariant="warning"
      buttonText="Discard Fax"
      buttonIsBlock={true}
      buttonIsDisabled={disallowEditing}
      popoverTitle="Discard Response Fax"
      buttonId="unprocessable-fax-details-btn-discard-popover"
    >
      <p className="confirmation-text">
        Do you want to <b>discard</b> this fax?
      </p>
      <div className="align-content-right">
        <Button
          id="switchdetails-btn-approve"
          className="left-spacer"
          variant="danger"
          onClick={handleDiscard}
        >
          Discard
        </Button>
      </div>
    </ButtonWithPopover>
  );
};

export default DiscardFax;
